import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Store } from '@ngrx/store';
import { AUTH_AUTO_LOGIN_RESOLVED, CLAIMS_INFO, TENANTS_INFO } from '@fitness-force/state';
import { AuthSevices } from '@fitness-force/api';
import { CONSTANTS_DATA } from '@fitness-force/constants';
import type { TENANTSINTERFACE } from '@fitness-force/models';
import { filter, Observable, of, switchMap, take } from 'rxjs';
import { sanitizeInternalReturnUrl } from '../../utils/sanitize-return-url';

@Injectable({
  providedIn: 'root',
})
export class AuthguardService implements CanActivate {
  private authservice = inject(AuthSevices);
  private router = inject(Router);
  private store = inject(Store);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    return this.store.select(AUTH_AUTO_LOGIN_RESOLVED).pipe(
      filter((resolved) => resolved === true),
      take(1),
      switchMap(() => this.authservice.ensureAccessTokenValid()),
      switchMap((valid) => {
        if (!valid) {
          const returnUrl = state.url.includes('?')
            ? state.url.split('?')[0]
            : state.url;
          this.router.navigate(['/auth/login'], {
            queryParams: {
              returnUrl: sanitizeInternalReturnUrl(
                returnUrl,
                CONSTANTS_DATA.DEFAULT.LOGIN_SUCCESS_REDIRECTION
              ),
            },
          });
          return of(false);
        }
        return this.checkClaimsAndTenant(route, state);
      })
    );
  }

  private checkClaimsAndTenant(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.store.select(TENANTS_INFO).pipe(
      take(1),
      switchMap((tenantState: TENANTSINTERFACE) => {
        const selectedTenant = tenantState?.selected_tenant;
        return this.store.select(CLAIMS_INFO).pipe(
          take(1),
          switchMap((claimsData: any) => {
            if (route?.data?.claim && !(String(claimsData.role).toLowerCase() === 'admin')) {
              if (claimsData[route.data.claim] != undefined && claimsData[route.data.claim] == 'true') {
                if (route?.data?.tenant && selectedTenant?.status && (selectedTenant?.status.toLowerCase() == 'active' || selectedTenant?.status.toLowerCase() == 'presales')) {
                  return of(true);
                }
                else if (selectedTenant && selectedTenant?.status.toLowerCase() == 'inactive') {
                  this.router.navigate(['/tenant-not-found']);
                  return of(false);
                }
                else {
                  return of(true);
                }
              } else {
                if (
                  selectedTenant?.status &&
                  (selectedTenant?.status.toLowerCase() == 'active' || selectedTenant?.status.toLowerCase() == 'presales')
                ) {
                  return of(true);
                } else {
                  this.router.navigate(['/tenant-not-found'], {
                    queryParams: { returnUrl: state.url },
                  });
                  return of(false);
                }
              }
            } else {
              if (selectedTenant && selectedTenant?.status.toLowerCase() == 'inactive') {
                this.router.navigate(['/tenant-not-found']);
                return of(false);
              }
              else {
                return of(true);
              }
            }
          })
        );
      })
    );
  }
}
